var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgClockGreen(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 14,
    viewBox: "0 0 13 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.4999 13.8438C2.92353 13.8438 0 10.9202 0 7.34375C0 3.76733 2.92353 0.84375 6.4999 0.84375C10.0763 0.84375 12.9998 3.76733 12.9998 7.34375C13.0282 10.9202 10.1046 13.8438 6.4999 13.8438ZM6.4999 1.52497C3.29252 1.52497 0.709596 4.13633 0.709596 7.31536C0.709596 10.4944 3.32091 13.1058 6.4999 13.1058C9.67889 13.1058 12.2902 10.4944 12.2902 7.31536C12.2902 4.13633 9.70727 1.52497 6.4999 1.52497Z",
    fill: "#28A745"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.54544 10.6638L6.13281 8.25113V3.85156H6.89918V7.9389L9.08473 10.1245L8.54544 10.6638Z",
    fill: "#28A745"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClockGreen);
export default __webpack_public_path__ + "static/media/clock-green.3e8d72bb0e6a565e5108d89d49a9b8e8.svg";
export { ForwardRef as ReactComponent };